import React, { useCallback, useEffect, useState } from "react";
import Header from "../../../Layouts/Components/Header";
import { Grid, Box, Modal } from "@mui/material";
import GroupsList from "./GroupsList";
import Group from "./Group";
import ScreenLoader from "../../shared/ScreenLoader";
import {
  getMessageTypes,
  getTemplates,
  GroupList,
  EditGroup,
  resetAllGroups,
  CreateGroup,
  RemoveGroup,
  CustomersList,
} from "../state/alertActions";
import useSnackBar from "../../Hooks/useSnackBar";
import { useDispatch, useSelector } from "react-redux";
import { useFormik, FormikProvider } from "formik";
import * as yup from "yup";
import NoItemSelected from "../../shared/NoItemSelected";
import usePrompt from "../../Hooks/usePrompt";
import { useNavigate } from "react-router-dom";
import SaveChangesModal from "../../shared/SaveChangesModal";
import ModalAlerts from "../../shared/DeleteModal";
import {
  direction,
  sendingType,
  notificationType,
} from "../../../utils/constantDropdowns";
const CustomerGroups = () => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [pendingCurrentLicense, setPendingCurrentLicense] = useState(null);
  const [addNew, setAddNew] = useState(false);
  const [groupId, setGroupId] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const Navigate = useNavigate();
  const [pendingLocation, setPendingLocation] = useState(null);

  const { success, error, snackbar } = useSnackBar();
  const loadMessageType = useCallback(
    () => dispatch(getMessageTypes(error)),
    [error, dispatch]
  );
  const loadTemplates = useCallback(
    () => dispatch(getTemplates(error)),
    [error, dispatch]
  );
  const loadGroups = useCallback(
    () => dispatch(GroupList(true, error)),
    [error, dispatch]
  );
  const resetAGroups = useCallback(
    () => dispatch(resetAllGroups()),
    [dispatch]
  );
  const loadCustomers = useCallback(
    () =>
      dispatch(
        CustomersList(
          {
            pageNumber: 1,
            pageSize: 10,
          },
          error
        )
      ),
    [dispatch, error]
  );

  const {
    messageTypes,
    NotificationTemplates,
    SelectedGroup,
    loadingGroups,
    AllCustomers,
    AllGroups,
    rows,
  } = useSelector((state) => state.CustomersGroups);

  const state = useSelector((state) => state.CustomersGroups);
  console.log(state);

  const [touched, setTouched] = useState(false);
  let defaultTemplate = NotificationTemplates.filter(
    (temp) => temp.isDefault
  )[0];
  const validationSchema = yup.object().shape({
    name: yup.string().required(),
    MT: yup.array().of(
      yup.object().shape({
        messageNumber: yup
          .mixed()
          .required("MessageType is required")
          .nullable(),
        direction: yup.string().required("way is required"),
        sendingType: yup.string().required("sendingType is required"),
      })
    ),
  });
  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: true,
    initialValues: {
      name: SelectedGroup?.name,
      groupId: SelectedGroup?.id || "",
      MT: SelectedGroup?.criteria?.map((mt) => ({
        messageNumber: messageTypes.filter(
          (temp) => temp.id === mt.messageTypeId
        )[0],
        sendingType: mt.sendingType || sendingType[2],
        direction: mt.way || "",
        notificationTemplate:
          NotificationTemplates.filter(
            (temp) => temp.id === mt.templateId
          )[0] || defaultTemplate,
      })) || [
        {
          messageNumber: null,
          sendingType: sendingType[2],
          direction: "",
          notificationTemplate: defaultTemplate,
        },
      ],
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      if (values.groupId) {
        let data = {
          name: values.name.trim(),
          id: values.groupId,
          criteria: values.MT.map((mt) => ({
            templateId: mt.notificationTemplate.id,
            messageTypeId: mt.messageNumber.id,
            way: mt.direction,
            sendingType: mt.sendingType,
          })),
        };
        dispatch(EditGroup(data, success, error)).then(() => {
          dispatch(GroupList(false, error)).then(() => {
            if (pendingCurrentLicense) {
              dispatch({ type: "ADD_GROUP", payload: pendingCurrentLicense });
            }
          });
        });
      } else {
        let data = {
          name: values.name.trim(),
          notificationType: values.notificationType,
          criteria: values.MT.map((mt) => ({
            templateId: mt.notificationTemplate.id,
            messageTypeId: mt.messageNumber.id,
            way: mt.direction,
            sendingType: mt.sendingType,
          })),
        };
        dispatch(CreateGroup(data, success, error)).then(() => {
          dispatch(GroupList(false, error)).then(() => {
            if (pendingCurrentLicense) {
              dispatch({ type: "ADD_GROUP", payload: pendingCurrentLicense });
            }
          });
        });
      }
      setPendingCurrentLicense(null);
      setIsConfirmationModalOpen(false);
      setTouched(false);
      setAddNew(false);
    },
  });

  //navigate to pendingLocation effect
  useEffect(() => {
    if (pendingLocation && !touched) Navigate(pendingLocation);
  }, [Navigate, pendingLocation, touched]);

  const handleBlockedNavigation = useCallback(
    (nextLocation) => {
      if (nextLocation.pathname === "/customers-groups") return true;
      if (touched) {
        setPendingLocation(nextLocation.pathname);
        setIsConfirmationModalOpen(true);
        return false;
      }
      return true;
    },
    [touched]
  );
  usePrompt(handleBlockedNavigation, touched);

  const handleCloseConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setPendingCurrentLicense(null);
  };

  const handleConfirmSaveChanges = () => {
    formik.handleSubmit();
  };

  const handleDiscardChanges = () => {
    dispatch({ type: "ADD_GROUP", payload: pendingCurrentLicense });
    setPendingCurrentLicense(null);
    setIsConfirmationModalOpen(false);
    setTouched(false);
    setAddNew(false);
  };
  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
    e.stopPropagation();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    loadMessageType();
    loadTemplates();
    loadGroups();
    loadCustomers();
    return () => {
      resetAGroups();
    };
  }, [loadMessageType, loadTemplates, loadGroups, resetAGroups, loadCustomers]);

  const handleDelete = (id) => {
    setGroupId(id);
    setOpenDeleteModal(true);
  };

  const handleDeleteAction = () => {
    dispatch(RemoveGroup(groupId, success, error)).then(() => {
      dispatch(GroupList(false, error));
      setOpenDeleteModal(false);
      setGroupId(null);
    });
  };

  const groupsMenu = [
    {
      id: 1,
      action: "Delete",
      handler: handleDelete,
    },
  ];
  return (
    <>
      {snackbar}
      <SaveChangesModal
        open={isConfirmationModalOpen}
        onClose={handleCloseConfirmationModal}
        discardChanges={handleDiscardChanges}
        saveChanges={handleConfirmSaveChanges}
      />

      <Modal
        open={openDeleteModal}
        handleClose={() => setOpenDeleteModal(false)}
      >
        <ModalAlerts
          title="Permenantly Delete Group"
          btnTitle="Delete Group"
          content={
            "Are you sure you want to delete Group? data will no longer be restored."
          }
          handleCloseModal={() => setOpenDeleteModal(false)}
          action={handleDeleteAction}
        />
      </Modal>
      {messageTypes.length > 0 && NotificationTemplates.length > 0 ? (
        <>
          <Header headLine="Customers Groups List" />
          <Grid container columnSpacing={2}>
            <Grid item md={3} xs={3}>
              <Box
                sx={{
                  background: "#ffffff",
                  height: "100vh",
                  overflow: "auto",
                  borderRight: "1px solid #E7E9EF",
                }}
              >
                <GroupsList
                  formik={formik}
                  Groups={AllGroups}
                  CurrentGroup={SelectedGroup}
                  touched={touched}
                  setTouched={setTouched}
                  setPendingCurrentLicense={setPendingCurrentLicense}
                  setIsConfirmationModalOpen={setIsConfirmationModalOpen}
                  setAddNew={setAddNew}
                  addNew={addNew}
                  error={error}
                  state={state}
                />
              </Box>
            </Grid>
            <Grid item md={9} xs={9}>
              {loadingGroups ? (
                <ScreenLoader />
              ) : !SelectedGroup ? (
                <NoItemSelected />
              ) : (
                <FormikProvider value={formik}>
                  <Group
                    menu={groupsMenu}
                    handleOpenMenu={handleClick}
                    anchorEl={anchorEl}
                    handleCloseMenu={handleClose}
                    SendingType={sendingType}
                    Direction={direction}
                    messageTypes={messageTypes}
                    NotificationTemplates={NotificationTemplates}
                    notificationType={notificationType}
                    defaultTemplate={defaultTemplate}
                    formik={formik}
                    setTouched={setTouched}
                    touched={touched}
                    CurrentGroup={SelectedGroup}
                    Customers={AllCustomers}
                    error={error}
                    success={success}
                    rows={rows}
                  />
                </FormikProvider>
              )}
            </Grid>
          </Grid>
        </>
      ) : (
        <ScreenLoader />
      )}
    </>
  );
};

export default CustomerGroups;
